import { PageTagihanV2, PageTagihanDetailV2 } from "@/pages/InfoPelanggan/v2";

export const TagihanRouterV2 = [
    {
        path: 'v2/info-tagihan',
        element: <PageTagihanV2 />
    },
    {
        path: 'v2/info-tagihan/:id',
        element: <PageTagihanDetailV2 />
    },
]

